import React from 'react';
import './Footer.css';
import logo from "../../img/Logo-for-pddl.jpg";
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPhone, faEnvelope, faMapMarked} from '@fortawesome/free-solid-svg-icons'
import Iframe from 'react-iframe';
import { Card, CardGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const element = <FontAwesomeIcon icon={faPhone} />
const element2 = <FontAwesomeIcon icon={faEnvelope} />
const element3 = <FontAwesomeIcon icon={faMapMarked} />

const Footer = () => {
    return (
        <div className="footer text-center">
            <div className="row">
                {/* first column */}
                <div className="col-md-6 col-lg-4 col-sm-12 text-light py-3">
                    <NavLink to="/home">
                        <img className="mb-4 d-flex justify-content-start ms-5 mt-4" src={logo} alt="" width="90px" />
                    </NavLink>
                    <div className='d-flex ms-5'>
                    <NavLink to="/home" className="items m-0 ps-0" id="items">
                        <li className='h6 fw-bold'>Home | </li>
                    </NavLink>
                    <NavLink to="/about" className="items m-0" id="items">
                        <li className='h6 fw-bold'>About | </li>
                    </NavLink>
                    <NavLink to="/training" className="items m-0" id="items">
                        <li className='h6 fw-bold'>Training | </li>
                    </NavLink>
                    <NavLink to="/clients" className="items m-0" id="items">
                        <li className='h6 fw-bold'>Clients |</li>
                    </NavLink>
                    <Link to="/home#contact" className="items m-0" id="items">
                        <li className='h6 fw-bold'>Contact Us</li>
                    </Link>
                    </div>
                    <div className="text-light h6 mb-0 last ms-5">
                        <p className='m-0'>All rights reserved &copy; 2022 PDDL </p>
                        <p className='m-0'>Developed by DazingDevs</p>
                    </div>
                    
                </div>
                {/* second column */}
                <div className="col-md-6 col-lg-4 col-sm-12 text-light p-3 mt-4">
                <h4 className="fw-bold footer-heading ps-5">Contact</h4>
                    <h5 className="footer-heading ps-5 fw-light">{element} +88018-86715960, +88017-64715960<br></br>
                    {element2} pddl.bd20@gmail.com <br></br>
                    {element3} 9th Floor, Mukto Bangla Shoping Complex, Mirpur-1, Dhaka-1216, Bangladesh.</h5>
                </div>
                {/* third column */}
                <div className="col-md-6 col-lg-4 col-sm-12 text-light p-3 mt-4 padding-left">
                    <h4 className="footer-heading fw-bold">About</h4>
                    <h5 className="footer-heading2 fw-light pe-5"><strong className='fw-bold'>PROPER Design & Development Limited</strong><br></br> Maximum safety, minimum cost and serviceability is our tradition</h5>
                </div>
            </div>
        </div>
    );
};

export default Footer;